import { call, takeEvery, put, all } from "redux-saga/effects";

import {
  getGosInitData,
  getGosInitDataFailure,
  getGosInitDataIdle,
  getGosInitDataSuccess,
} from "../actions";
import { getGosInitDataRequest } from "../api";

import { gosSiteUrl, INIT_DATA_LISTS } from "../config";
import { DynamicType } from "../reducers";

function* getGosInitDataSaga() {
  try {
    let initData: DynamicType = {};
    for (let i = 0; i < INIT_DATA_LISTS.length; i++) {
      const data: { items: [] } = yield call(getGosInitDataRequest, {
        listName: INIT_DATA_LISTS[i],
      });
      initData = { ...initData, [INIT_DATA_LISTS[i]]: data.items };
    }

    yield put(getGosInitDataSuccess(initData));
  } catch (error) {
    console.log(error);
    yield put(getGosInitDataFailure(error));
  }
}

export function* gosWatcher() {
  yield takeEvery(getGosInitData.toString(), getGosInitDataSaga);
}
